import {
  PTRDataStoreBlankItem,
  PTRDataStoreType,
} from '@app/data-stores/ptr/types';
import type { InventoryItem } from '@app/types/shop-bff/types';
import type { InventoryBySelector } from '../hooks/usePTRProductConfigurator';
import {
  buildBlankItemsById,
  buildCanonicalInventoryIndex,
} from './ptrConfiguratorUtils';

export type PTRInventoryProps = {
  blankItemsById: Record<string, PTRDataStoreBlankItem>;
  inventoryBySelector: InventoryBySelector;
};

export const getPTRInventoryProps = (
  productTypes: PTRDataStoreType['productTypes'],
  inventoryItems: InventoryItem[]
): PTRInventoryProps => {
  const blankItemsById = buildBlankItemsById(productTypes);
  const inventoryBySelector = buildCanonicalInventoryIndex(
    inventoryItems,
    blankItemsById
  );
  return { blankItemsById, inventoryBySelector };
};
